import React,{useContext, useEffect, useState} from 'react';
import AuthContext from '../../context/auth/authContext';
import AlertContext from '../../context/alert/alertContext';
import {useParams, useNavigate } from "react-router-dom";
import Alerts from '../layout/Alerts';

import { Container, Button, Form,Row, Col} from "react-bootstrap";
import logo from '../../img/logo.svg';


import RecoveryEmailForm from './RecoveryEmailForm';


const Recovery = () => {

    const alertContext = useContext(AlertContext);


    const params = useParams();

    const {setAlert} = alertContext;
    const authContext = useContext(AuthContext);
    const{login, error, isAuthenticated, clearErrors} = authContext;

    const navigate = useNavigate();

    useEffect(() => {
        if(isAuthenticated){
            navigate('/');
        }
        if(error === 'Invalid Credentials'){
            //do something
            setAlert(error, 'danger');
            clearErrors();
            //console.log('Invalid Credentials error handler');
            
        }
        // eslint-disable-next-line
    },[error,isAuthenticated])

 

    const [user, setUser] = useState({
        email: ''
    });

    const [showRecoveryForm, setShowRecoveryForm]= useState(false);


    const [emailSucess, setEmailSuccess] = useState(false);

    useEffect( () =>{

        if(params.code){
            setShowRecoveryForm(true);
        }
        // eslint-disable-next-line
    },[])



    return (
    <>
        <div className='d-none d-md-block'></div>
        <Container>

            <h1 className='h1 mt-5 font-size-0'>
                <img src={logo} className='logo' /> Bladonmore portal
            </h1>
        </Container>
        <Container>
            <Row className='justify-content-center'>
                <Col md="6" className='d-flex flex-column justify-content-center h-100 form-container pe-5'>
                    <div className='alerts'>
                        <Alerts />
                    </div>
                    <h2 className='mb-4 login-h2'>Recover your password</h2>

                    {emailSucess ? 
                        <p className="alert-success">
                            A recovery code has been sent to your email address
                        </p>
                    :
                        <RecoveryEmailForm setEmailSuccess={setEmailSuccess}/>
                                    
                    }

                </Col>
            </Row>
        </Container>
    </>
    )
}

export default Recovery